export var LockStatus;
(function (LockStatus) {
    LockStatus["Open"] = "Open";
    LockStatus["Closed"] = "Closed";
    LockStatus["Blocked"] = "Blocked";
    LockStatus["Breakin"] = "Breakin";
})(LockStatus || (LockStatus = {}));
export var Language;
(function (Language) {
    Language["DE"] = "de";
    Language["EN"] = "en";
    Language["FR"] = "fr";
    Language["RU"] = "ru";
    Language["ET"] = "et";
    Language["IT"] = "it";
    Language["CS"] = "cs";
    Language["PL"] = "pl";
    Language["TR"] = "tr";
})(Language || (Language = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel["Audit"] = "Audit";
    LogLevel["Trace"] = "Trace";
})(LogLevel || (LogLevel = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["NfcReader"] = "NfcReader";
    DeviceType["PaymentTerminal"] = "PaymentTerminal";
    DeviceType["Locking"] = "Locking";
    DeviceType["BarcodeReader"] = "BarcodeReader";
    DeviceType["Admission"] = "Admission";
})(DeviceType || (DeviceType = {}));
export var AccessCodeAlphabet;
(function (AccessCodeAlphabet) {
    AccessCodeAlphabet["OneToNine"] = "123456789";
})(AccessCodeAlphabet || (AccessCodeAlphabet = {}));
export * from "./barcode-reader.js";
export * from "./doorbell.js";
export * from "./keypad.js";
export * from "./nfc-reader.js";
export * from "./payment-terminal.js";
//# sourceMappingURL=index.js.map